<div fxLayout="column">
    <app-sidenav class="height-cont"></app-sidenav>
</div>